import * as React from 'react';

interface IconProps {
  width?: number;
  height?: number;
  fill?: string;
}

const TrashBinIcon = (props: IconProps) => {
  const { width = 20, height = 20 } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.33594 1H13.3359M1.33594 4H19.3359M17.3359 4L16.6347 14.5193C16.5294 16.0975 16.4768 16.8867 16.136 17.485C15.8358 18.0118 15.3832 18.4353 14.8376 18.6997C14.2179 19 13.427 19 11.8453 19H8.82659C7.24484 19 6.45397 19 5.83427 18.6997C5.28869 18.4353 4.83603 18.0118 4.53592 17.485C4.19505 16.8867 4.14244 16.0975 4.03722 14.5193L3.33594 4M8.33594 8.5V13.5M12.3359 8.5V13.5"
        stroke="#64748B"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export { TrashBinIcon };
